import { makeVar } from '@apollo/client';

export const paginatedNCRsQuery = makeVar({});
